module.exports = window;


//////////////////
// WEBPACK FOOTER
// external "window"
// module id = 4277
// module chunks = 63